import { Link } from 'react-router-dom';

interface AuthBrandHeaderProps {
  heading: string;
  subheading: string;
}

/**
 * Brand header for auth forms.
 */
export function AuthBrandHeader({ heading, subheading }: AuthBrandHeaderProps) {
  return (
    <div className="mb-8">
      <Link to="/" className="inline-flex items-center gap-3 mb-8">
        <img src="/vrmeet_logo.png" alt="VR Meet" className="h-10 w-10" />
        <span className="text-xl font-semibold bg-gradient-to-r from-brand-blue via-brand-teal to-brand-green bg-clip-text text-transparent">
          VR Meet
        </span>
      </Link>
      <h1 className="text-2xl font-bold text-gray-900 mb-2">
        {heading}
      </h1>
      <p className="text-gray-500">
        {subheading}
      </p>
    </div>
  );
}
